var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"flex xs-center xs-middle p2 bgWarning c1 fs4 loading-inner"},[_c('div',[_vm._v("\n\t\t\t"+_vm._s(_vm.$t("loading"))+"\n\t\t")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }